var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 72,
    viewBox: "0 0 64 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15538_101208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4438 35.0119L39.8699 30.3957L40.4489 33.3137L17.0228 37.9299L16.4438 35.0119ZM18.2139 28.5989L35.7835 25.1367L36.3626 28.0547L18.793 31.5169L18.2139 28.5989ZM41.028 36.2318L17.6019 40.848C15.9913 41.1653 14.9342 42.7381 15.2527 44.343L17.5689 56.0151C17.8874 57.62 19.4656 58.6734 21.0762 58.356L44.5023 53.7398C46.1128 53.4225 47.17 51.8497 46.8515 50.2448L44.5353 38.5728C44.2168 36.9678 42.6385 35.9144 41.028 36.2318ZM43.9232 50.8218L20.4971 55.438L18.1809 43.766L41.607 39.1498L43.9232 50.8218ZM27.1771 43.1L29.0677 52.6273L36.9086 46.1399L27.1771 43.1Z",
    fill: "#D2D0CE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4079 69.6511L2.35156 24.0133L48.1624 14.9861L57.2188 60.624L11.4079 69.6511Z",
    stroke: "#D2D0CE",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6987 4.40397L59.5799 4.50707L59.4765 46.2417L56.3257 46.234L57.1979 50.6293L63.8741 50.6457L63.9994 0.1248L13.3011 0L13.252 19.8123L17.6627 18.9431L17.6987 4.40397Z",
    fill: "#D2D0CE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15538_101208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.8148,
    height: 35.6989,
    fill: "white",
    transform: "matrix(0.981133 -0.193336 0.194645 0.980874 8.84961 27.4121)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.6710f5150ead36533d52f58eedccdadc.svg";
export { ForwardRef as ReactComponent };